import * as React from 'react';

import { Feedback } from '../renderForQuestions/feedback';
import { INCORRECT_CONTINUE } from '../../utils/constants';

const FinalAttemptFeedback = ({ latestAttempt, correctResponse, translate, showTranslation, languageLocale }) => (
  <Feedback
    correctResponse={correctResponse}
    feedbackType={INCORRECT_CONTINUE}
    languageLocale={languageLocale}
    latestAttempt={latestAttempt}
    showTranslation={showTranslation}
    translate={translate}
  />
);

export { FinalAttemptFeedback };
